module.exports = __webpack_public_path__ + "static/world-map.0ac39056.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/HomePage/TopSection/world-map.svg
// module id = 699
// module chunks = 0